import { GzSingleSelectListWebComponent } from './component/GzSingleSelectListWebComponent';
import { WEB_COMPONENT_GZ_SINGLE_SELECT_LIST } from '../../webcomponents.constants';

export { GzSingleSelectListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_SINGLE_SELECT_LIST, GzSingleSelectListWebComponent);
